import { Badge } from 'antd'
import { channelModel } from 'apis/model'
import { channelSchema } from 'apis/schema'
import { ChannelIcon } from 'components/icons/ChannelIcon'
import { SelectEntityItem } from 'components/SelectEntityItem'
import React from 'react'
import { Link } from 'react-router-dom'
import getLinkToDetail from 'helpers/getLinkToDetail'

const renderChannel = (item, index) => {
  const id = channelModel.getId(item)
  const title = channelModel.getTitle(item)
  const to = getLinkToDetail(item)
  return (
    <SelectEntityItem
      key={index}
      item={id}
      schema={channelSchema}>
      {(item) => (
        <Link
          to={to}
          className="block">
          <div className="flex rounded-lg  cursor-pointer items-center px-2 py-1 mt-2 hover:text-primary">
            <ChannelIcon
              className="mr-2 text-2xl"
              premium={item.premium}
            />
            <div className="font-semibold flex-1">{title}</div>
            {item.has_unread && (
              <Badge
                dot
                color="blue"
              />
            )}
          </div>
        </Link>
      )}
    </SelectEntityItem>
  )
}

export default renderChannel
